export default "__VITE_ASSET__1qW3hkJh__"